/* eslint jsx-a11y/anchor-is-valid: "off" */

import React from 'react';
import PropTypes from 'prop-types';

import { ListNavLink, Icon, Button } from 'js/components';
import { Nav } from 'reactstrap';
import { Link } from 'react-router-dom';

function toggleSidebar() {
  document.body.classList.toggle('sidebar-mini');
}

function Sidebar() {
  return (
    <div>
      <div className="sidebar" data-color="green">
        <div className="logo">
          <Link to="/dashboard" className="simple-text logo-mini">
            <Icon icon={['fas', 'map-marker-alt']} />
          </Link>
          <Link to="/dashboard" className="simple-text logo-normal">
            Waypointr
          </Link>
          <div className="navbar-minimize">
            <Button
              simple
              neutral
              icon
              round
              color="transparent"
              id="minimizeSidebar"
              onClick={toggleSidebar}
            >
              <i className="visible-on-sidebar-regular">
                <Icon icon="align-center" />
              </i>
              <i className="visible-on-sidebar-mini">
                <Icon icon="list-ul" />
              </i>
            </Button>
          </div>
        </div>

        <div className="sidebar-wrapper">
          <Nav>
            <ListNavLink
              to={`/dashboard`}
              exact
              className="nav-link"
              activeClassName="active"
            >
              <i>
                <Icon icon="tachometer-alt" fixedWidth />
              </i>
              <p>Dashboard</p>
            </ListNavLink>
          </Nav>
        </div>
      </div>
    </div>
  );
}

Sidebar.propTypes = {
  me: PropTypes.object.isRequired,
};

export default Sidebar;
